import { useEffect, useState } from 'react'

/** Follows `document.documentElement` `.dark` like UI theme. */
export function useDocumentDarkClass(): boolean {
  const [isDark, setIsDark] = useState(() =>
    typeof document !== 'undefined'
      ? document.documentElement.classList.contains('dark')
      : false,
  )

  useEffect(() => {
    const sync = () =>
      setIsDark(document.documentElement.classList.contains('dark'))
    sync()
    const mo = new MutationObserver(sync)
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
    return () => mo.disconnect()
  }, [])

  return isDark
}
